import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMundialTeams } from './../../redux/actions/teams.actions';
import { usePrivateRoute } from '../../hooks/usePrivateRoute';
//--------------------------------------------------------------------------
import { TeamItem } from 'containers/MundialViews/components/TeamItem';
import './style.scss';

export const TeamsView = () => {
  usePrivateRoute()
  const { Teams } = useSelector(state => state.Mundial);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Teams.length > 0) return;
    dispatch(getMundialTeams());

    
    
  }, []);


  return (
    <div className="teams-view">
      {Teams?.map((team, i) => (
        <TeamItem
          key={`teams-view-${team.id}-${i}`}
          teamInfo={team}
          actionTag={'equipos'}
          containerStyles={{ width: '144px', height: '144px' }}
          imageStyles={{ width: 88, height: 88 }}
          marginBottom={44}
        />
      ))}
    </div>
  );
};
